import { useState } from 'react'
import { BookMarked, BookOpenText, Bot, FileCode2 } from 'lucide-react'
import { CardTabs } from '../components/CardTabs'
import { ApiSpecView } from './noti/ApiSpecView'
import { AiDocsView } from './noti/AiDocsView'
import { DocsView } from './noti/DocsView'

// Public-facing documentation: the filtered OpenAPI (trigger / subscribers /
// preferences / topics only) plus the Thai integration handbook. This page
// stays accessible without portal auth — it IS the handout for other teams.
export default function ApiDocsPage() {
  const [tab, setTab] = useState<'reference' | 'handbook' | 'ai'>('reference')
  return (
    <>
      <div className="page-head">
        <h2><BookOpenText size={20} /> API Docs</h2>
      </div>
      <p className="page-desc muted">
        เอกสารสาธารณะสำหรับทีมระบบงานทุกทีม — API Reference เปิดเผยเฉพาะ 4 หมวดที่ใช้เชื่อมต่อ:
        <b> trigger · subscribers · preferences · topics</b> (ส่วน admin ไม่อยู่ในสเปคฉบับนี้)
        · แท็บ <b>เอกสารสำหรับ AI</b> = llms.txt สำหรับป้อน AI agent ของแต่ละทีม
      </p>
      <CardTabs
        tabs={[
          { key: 'reference', label: 'API Reference', icon: FileCode2 },
          { key: 'handbook', label: 'คู่มือ (Handbook)', icon: BookMarked },
          { key: 'ai', label: 'เอกสารสำหรับ AI', icon: Bot },
        ] as const}
        active={tab}
        onChange={setTab}
      />
      {tab === 'reference' ? (
        <ApiSpecView
          specPath="/api/portal/noti/openapi.public.yaml"
          title="API Reference (ฉบับสาธารณะ)"
          note="สเปคที่กรองแล้วสำหรับทีมภายนอก — กด Authorize ใส่ X-Client-Id + X-Client-Secret ของ client คุณ แล้วกด Try it out → Execute เพื่อยิงทดสอบจริงได้เลย"
        />
      ) : tab === 'handbook' ? (
        <DocsView />
      ) : (
        <AiDocsView />
      )}
    </>
  )
}
